export const toTitleCase = string => {
  return string.replace(/\b[a-zA-Z]/g, match => match.toUpperCase());
};
